import { useContext } from 'react';
import { DetailsBookingContext } from './DetailsBookingProvider';

const useDetailsBooking = () => {
  const { booking, refetch } = useContext(DetailsBookingContext);

  if (!booking) {
    throw new Error('useDetailsBooking() can only be used under <DetailsBookingProvider />');
  }

  return { booking, refetch };
};

export default useDetailsBooking;
